import './App.scss';
import { Flex, Text, VStack } from '@chakra-ui/react';
import { Button, ButtonGroup } from '@chakra-ui/react'
import { useState, useEffect } from 'react';

import Square from './components/Square';
import { Patterns } from './components/Patterns';

function App() {
  const AppName = "TicTacToe";
  
  const [Board, setBoard] = useState([" "," "," "," "," "," "," "," "," "])
  const [Player, setPlayer] = useState("X");

  const [Result, setResult] = useState({ winner: "none", state: "none" });

  useEffect(() => {
    checkWin();
    checkIfTie();

    if (Player == "X") {
      setPlayer("O");
    } else {
      setPlayer("X");
    }
  }, [Board]);

  useEffect(() => {
    if (Result.state != "none") {
      alert(`Game Finished! Winning Player: ${Result.winner}`);
      restartGame();
    }
  }, [Result]);

  const ClickSquare = (square) => {
    setBoard(
      Board.map((val, idx) => {
        if (idx == square && val == "") {
          return Player;
        }

        return val;
      })
    );
  };

  const checkWin = () => {
    Patterns.forEach((currPattern) => {
      const firstPlayer = Board[currPattern[0]];
      if (firstPlayer == "") return;
      let foundWinningPattern = true;
      currPattern.forEach((idx) => {
        if (Board[idx] != firstPlayer) {
          foundWinningPattern = false;
        }
      });

      if (foundWinningPattern) {
        setResult({ winner: Player, state: "Won" });
      }
    });
  };

  const checkIfTie = () => {
    let filled = true;
    Board.forEach((square) => {
      if (square == "") {
        filled = false;
      }
    });

    if (filled) {
      setResult({ winner: "No One", state: "Tie" });
    }
  };

  const restartGame = () => {
    setBoard(["", "", "", "", "", "", "", "", ""]);
    setPlayer("O");
  };

  return (
    <div className="App">
      <Text fontSize="3xl" as="b" className="heading">{AppName}</Text>

      <Text fontSize="xl" className="description">
        A Simple Game created using React & Chakra
      </Text>

      <Flex
        bg="#ddd" 
        w="auto" 
        h="200px"
        display="flex"
        direction="column"
        justify="center"
        align="center"
        marginTop={5}
        className="Board"
      >
        {/* <VStack> */}
          <ButtonGroup spacing='2' m="1">
            <Square 
              val={Board[0]} 
              chooseSquare={() => {
                ClickSquare(0);
              }}
            />
            <Square
              val = {Board[1]}
              chooseSquare = {() => {
                ClickSquare(1);
              }} 
            />
            <Square
              val = {Board[2]}
              chooseSquare = {() => {
                ClickSquare(2);
              }} 
            />
          </ButtonGroup>
          <ButtonGroup spacing='2' m="1">
            <Square
              val = {Board[3]}
              chooseSquare = {() => {
                ClickSquare(3);
              }} 
            />
            <Square
              val = {Board[4]}
              chooseSquare = {() => {
                ClickSquare(4);
              }} 
            />
            <Square
              val = {Board[5]}
              chooseSquare = {() => {
                ClickSquare(5);
              }} 
            />
          </ButtonGroup>
          <ButtonGroup spacing='2' m="1">
            <Square
              val = {Board[6]}
              chooseSquare = {() => {
                ClickSquare(6);
              }} 
            />
            <Square
              val = {Board[7]}
              chooseSquare = {() => {
                ClickSquare(7);
              }} 
            />
            <Square
              val = {Board[8]}
              chooseSquare = {() => {
                ClickSquare(8);
              }} 
            />
          </ButtonGroup>
        {/* </VStack> */}
      </Flex>
    </div>
  );
}

export default App;
